import { Link } from 'react-router-dom';
import { ROUTES } from '../routes.js';
import './LegalPage.css';
import './Danke.css';

export default function Danke() {
  return (
    <article className="legal danke">
      <div className="danke__mark" aria-hidden="true">
        <svg viewBox="0 0 48 48" fill="none">
          <circle cx="24" cy="24" r="22" stroke="currentColor" strokeOpacity="0.2" strokeWidth="1.5" />
          <path d="M14 24.5l7 7 13-15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </div>

      <span className="eyebrow">Anfrage erhalten</span>
      <h1>Vielen Dank – wir melden uns diskret.</h1>
      <p>
        Ihre Anfrage ist bei uns eingegangen. Ein persönlicher Scout aus Ihrer
        Wunschregion setzt sich innerhalb von 48 Stunden mit Ihnen in Verbindung –
        telefonisch oder über den von Ihnen bevorzugten Kanal.
      </p>
      <p>
        Bis dahin: keine weiteren Mails, keine Newsletter, keine Makler-Anrufe.
        Versprochen.
      </p>

      <div className="danke__actions">
        <Link to={ROUTES.home} className="btn-primary">
          Zur Startseite
        </Link>
      </div>
    </article>
  );
}
